export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-83414452d65fb13c1689.worker.js");
}
